import {
    getInvoiceProviderIdLoading,
    getInvoiceProviderIdRequest,
    getInvoiceProviderIdSuccess,
    getInvoiceProviderIdReject,
} from "../../actions/invoiceProvider/getId";

export const getInvoiceProviderId = (formData) => async (dispatch, getState) => {
    dispatch(getInvoiceProviderIdLoading());
    try {
        const { data } = await getInvoiceProviderIdRequest(formData, getState);
        dispatch(getInvoiceProviderIdSuccess(data))
    } catch (error) {
        dispatch(getInvoiceProviderIdReject(error))
    }
    return Promise.resolve();
};